import { updateButtonVisibility } from "../bet/updateButtonVisibility.js";
import { toggle } from "../toggle/toggle.js";
import { toSVG } from "../helpers/toSVG.js";
import {cancelModalTimers, scheduleModal, markModalOpened} from './modalState.js';

const openModal = alert => {
    cancelModalTimers(alert);
    markModalOpened(alert);
    alert.classList.remove('height');
    alert.classList.add('open');
    alert.dataset.modalOpening = '1';
    scheduleModal(alert, () => {
        if (alert.dataset.modalOpening !== '1') return;
        delete alert.dataset.modalOpening;
        if (alert.classList.contains('open')) alert.classList.add('show');
    }, 300);
};

export const alertFunc = (e, item) => {

    if (e) e.preventDefault();

    const title = item.getAttribute('data-title');
    const alert = document.querySelector(`.item-close[data-alert="${title}"]`);

    if (!alert) return false;
    if (alert.querySelector('.show-more-block')) setTimeout(() => updateButtonVisibility(), 500);

    if (alert.classList.contains('modal')) {
        if (!alert.classList.contains('notification')) document.body.classList.add('over-y-hide');
        openModal(alert);
        toggle();
    } else {
        alert.classList.remove('hidden');
        setTimeout(() => alert.classList.remove('height'), 250);
    }
    toSVG();
};

export const alertFuncPreloadInit = () => {

    const alerts = document.querySelectorAll('.form-preload-js');
    if (alerts.length) {
        alerts.forEach(alert => {
            if (alert.querySelector('.show-more-block')) setTimeout(() => updateButtonVisibility(), 500);

            if (alert.classList.contains('modal')) {
                if (!alert.classList.contains('notification')) document.body.classList.add('over-y-hide');
                openModal(alert);
                toggle();
            } else {
                alert.classList.remove('hidden');
                setTimeout(() => alert.classList.remove('height'), 250);
            }
        });
    }
};
